<div
  class="hamburger-div"
  (mouseleave)="onMouseLeave()"
  (mouseenter)="onMouseEnter()"
>
  <button
    class="hamburger-button"
    [ngClass]="{ pressed: !closed }"
    [ngStyle]="{ 'background-color': closed ? '' : 'var(--green)' }"
    (click)="toggleDropdown()"
    [@transitionExpand]="closed ? 'normal' : 'expanded'"
  >
    <span
      [ngStyle]="{ color: closed ? '' : 'var(--tan)' }"
      class="material-symbols-outlined"
    >
      &#xe5d2;
    </span>
  </button>

  <div
    class="dropdown-content"
    id="content"
    [@transitionOpen]="closed ? 'closed' : 'open'"
  >
    @if (showManagements) {
      <a routerLink="/reports-management">
        <button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          Reports
        </button>
      </a>
    }

    @if (showManagements) {
      <a routerLink="/ingredient-management">
        <button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          Ingredients
        </button>
      </a>
    }

    @if (loggedIn) {
      <a (click)="createNew.emit()"
        ><button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          Create
        </button></a
      >
    }

    @if (loggedIn) {
      <a routerLink="/plan">
        <button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          Plan
        </button>
      </a>
    }

    @if (loggedIn) {
      <a routerLink="/cookbook">
        <button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          Recipes
        </button>
      </a>
    }

    @if (loggedIn) {
      <a routerLink="/settings">
        <button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          Settings
        </button>
      </a>
    }

    @if (!loggedIn) {
      <a [routerLink]="['/about']"
        ><button
          class="drop-button"
          (click)="toggleDropdown()"
        >
          About Us
        </button></a
      >
    }

    <button
      class="drop-button"
      (click)="logout()"
    >
      {{ logginButtonText }}
    </button>
  </div>
</div>
